import '@shared/wdyr-axe';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import setupAxios from '@shared/setupAxios';

import NotificationMessages from '@map/components/NotificationMessages';
import { clearState } from '@map/localStorage';
import CrashPage from '@shared/components/CrashPage';
import ErrorBoundary from '@shared/components/ErrorBoundary';
import lazyLoadSentry from '@shared/lib/sentry/lazyLoadSentry';
import reportError from '@shared/reportError';
import { TEST } from '@shared/util/env';
import { loadRequestedLocale } from '@shared/util/locale';
import { register } from '@shared/util/serviceWorker';
import Container from '@skill-survey/components/app/Container';
import MasterProvider from '@skill-survey/components/app/MasterProvider';
import store from './state/store';

import '@shared/globals';

// TODO: do we need react spring web?
if (TEST) {
  import('@react-spring/web').then(({ Globals }) => Globals.assign({ skipAnimation: true }));
}

setupAxios.withDefaults(store);
document.addEventListener('DOMContentLoaded', () => {
  loadRequestedLocale();
  lazyLoadSentry();
  let swRegistration: ServiceWorkerRegistration | null = null;
  register('/sw.js')
    .then((reg) => {
      swRegistration = reg;
    })
    .catch((ex: Error | null) => {
      if (ex) {
        reportError(ex, { level: 'warning' });
      }
    });
  const handleContinue = async () => {
    try {
      // Make sure the service worker is up to date, in case that caused the error
      await swRegistration?.update();
      // Clear the cached state, in case that caused the error. It will be re-fetched.
      await clearState();
    } finally {
      window.location.href = (window as any).base_url || '/';
    }
  };
  const root = document.querySelector('#j-app-root')!;
  const app = (
    <ErrorBoundary fallback={<CrashPage onContinue={handleContinue} />}>
      <MasterProvider store={store}>
        <Container />
        <NotificationMessages />
      </MasterProvider>
    </ErrorBoundary>
  );
  // TODO: not working properly yet
  const strict = false as boolean;

  createRoot(root).render(strict ? <StrictMode>{app}</StrictMode> : app);
});
